import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { QuestionnaireFillResponse, SubmitQuestionnaireBody } from '../../models';
import { baseUrl } from '../../utils/config';

// Public (no-auth) API for the candidate questionnaire fill flow.
// Uses a separate RTK Query API instance so it does not share the auth baseQuery.
export const questionnaireFillApi = createApi({
	reducerPath: 'questionnaireFillApi',
	tagTypes: ['QuestionnaireFill'],
	baseQuery: fetchBaseQuery({ baseUrl }),
	endpoints: (builder) => ({
		// GET /api/questionnaire/fill/:token
		getQuestionnaireFill: builder.query<QuestionnaireFillResponse, string>({
			query: (token) => ({ url: `questionnaire/fill/${token}` }),
			providesTags: ['QuestionnaireFill'],
		}),

		// PUT /api/questionnaire/fill/:token
		submitQuestionnaireFill: builder.mutation<QuestionnaireFillResponse, { token: string; body: SubmitQuestionnaireBody }>({
			query: ({ token, body }) => ({
				url: `questionnaire/fill/${token}`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['QuestionnaireFill'],
		}),
	}),
});

export const {
	useGetQuestionnaireFillQuery,
	useSubmitQuestionnaireFillMutation,
} = questionnaireFillApi;
